// Form validation for New credential form
const validate = require('validate.js');

// eslint-disable-next-line consistent-return
validate.validators.integerCustomMessage = function(
  value,
  options,
  key,
  attributes
) {
  if (value !== undefined && !Number.isInteger(Number(value))) {
    return options.message || 'must be an integer';
  }
};

export default {
  installWindowDuration: function(
    value,
    attributes,
    attributeName,
    options,
    constraints
  ) {
    if (attributes.installWindowEnabled) {
      return {
        presence: true,
        integerCustomMessage: {
          message: '^Please enter hours in whole numbers only.'
        }
      };
    }

    return null;
  }
};
